import styled from 'styled-components'
import {
  Button as BaseButton,
  Text,
  PersonAvatar,
  ListItem,
  ListHeader,
} from '@sketch/components'

export const HeaderSection = styled.section`
  padding: 16px 20px 25px; /* stylelint-disable-line scales/space */
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.B};
`

export const Copy = styled(Text.Span).attrs({
  textStyle: 'copy.quaternary.standard.C',
})`
  display: inline-block;
  line-height: 1.333; /* stylelint-disable-line scales/line-height */

  margin-bottom: 4px;
`

export const Button = styled(BaseButton)`
  /* Exists because the rule "& + button" of Button can't be changed using classes */

  [role='img'] {
    width: 16px;
    height: 16px;
  }
`

export const ActionWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  column-gap: 8px;

  ${Button} + [aria-haspopup="true"] {
    margin-left: 8px;
  }
`

export const LinkSection = styled.div`
  padding: 8px 8px 16px;
`

export const AuthorSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const AuthorWrapper = styled.div`
  display: flex;
  align-items: center;

  ${PersonAvatar} {
    margin-right: 8px;
  }
`

export const HeaderListItem = styled(ListHeader)`
  pointer-events: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const LinkListItem = styled(ListItem)`
  /* We need this to align the baseline of the text with the center
     of the icon */
  & > span {
    margin-top: 8px;
    line-height: 1;
  }

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.colors.background.tertiary.C};
  }
`

export const LinkListPrototypeCards = styled.div`
  display: flex;
  padding-top: 8px;
  padding-left: 12px;
`

export const LinkListPrototypeCard = styled.div`
  width: 80px;

  :not(:first-child) {
    margin-left: 8px;
  }
`
